// src/components/EmergencyModal.js
import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

Modal.setAppElement('#root'); // Important for accessibility

const positionStyles = {
  top: {
    top: '10%',
    transform: 'translate(-50%, 0%)',
    bottom: 'auto',
  },
  middle: {
    top: '50%',
    transform: 'translate(-50%, -50%)',
    bottom: 'auto',
  },
  bottom: {
    bottom: '10%',
    top: 'auto',          // <-- add this
    transform: 'translate(-50%, 0%)'
  }
};

const EmergencyModal = ({ isOpen, onClose, title, body, position = 'middle' }) => {
  const customStyle = {
    content: {
      position: 'fixed',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      ...positionStyles[position.toLowerCase()] || positionStyles.middle,
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '8px',
      width: '80%',
      maxWidth: '400px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
      zIndex: 9999
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9998
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyle}
      contentLabel="Alert Modal"
    >
      <div
        className="d-flex align-items-center justify-content-center flex-column"
        style={{ maxWidth: '90%', margin: '0 auto', textAlign: 'center' }}
      >
        <h2 style={{ color: '#d32f2f', marginTop: 0 }}>{title}</h2>
        <p style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>{body}</p>
        <button
          onClick={onClose}
          style={{
            marginTop: 20,
            padding: '10px 20px',
            backgroundColor: '#d32f2f',
            color: '#fff',
            border: 'none',
            borderRadius: 5
          }}
        >
          Close
        </button>
      </div>

    </Modal>
  );
};

EmergencyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  body: PropTypes.string,
  position: PropTypes.string
};

export default EmergencyModal;
